var __makeTemplateObject = this && this.__makeTemplateObject || function (cooked, raw) {
  if (Object.defineProperty) {
    Object.defineProperty(cooked, "raw", {
      value: raw
    });
  } else {
    cooked.raw = raw;
  }
  return cooked;
};
import { css } from 'styled-components';
import { theme } from '@shapeable/theme';
export var LANGUAGE_EN = {
  id: 'langugage-en',
  path: 'en',
  iso: 'en',
  locale: 'en_GB',
  name: 'English',
  label: 'English Version'
};
export var LANGUAGE_FR = {
  id: 'langugage-fr',
  path: 'fr',
  iso: 'fr',
  locale: 'fr_FR',
  name: 'Français',
  label: 'Version Français'
};
export var PLATFORM_DATETIME_FORMAT = 'YYYY-MM-DDTHH:mm:ss';
export var PLATFORM_DATE_FORMAT = 'YYYY-MM-DD';
export var PLATFORM_MONTH_FORMAT = 'YYYY-MM';
export var WARM_GREY = '#ECEDE8';
export var RED = '#FF0000';
export var GREEN = '#56C02B';
export var OVERLAY_SHADOW = '0 1px 1px rgba(0, 0, 0, 0.3)';
export var COLOR_WARM_GREY = {
  value: WARM_GREY
};
export var COLOR_GRAY = {
  id: 'color-gray',
  slug: 'color-gray',
  name: 'Gray',
  value: '#666666'
};
export var COLOR_WHITE = {
  id: 'color-white',
  slug: 'color-white',
  name: 'White',
  value: '#FFFFFF',
  darkValue: '#333333',
  lightValue: '#CCCCCC',
  veryLightValue: '#EEEEEE',
  veryDarkValue: '#111111'
};
export var COLOR_BLACK = {
  id: 'color-black',
  slug: 'color-black',
  name: 'Black',
  value: '#000000'
};
export var DEFAULT_SITE = {
  id: "website",
  name: 'Website',
  languages: [LANGUAGE_EN]
};
export var PAGE_HOME = {
  id: 'home',
  path: '/',
  name: 'Home'
};
export var PAGE_KNOWLEDGE_HUB = {
  id: 'knowledge-hub',
  path: '/knowledge-hub',
  name: 'Knowledge Hub'
};
export var PAGE_EVENTS = {
  id: 'events',
  path: '/events',
  name: 'Events'
};
export var PAGE_NOT_FOUND = {
  name: 'Page Not Found',
  slug: '',
  intro: {
    text: "# Sorry we couldn\u2019t find what you were looking for."
  },
  content: {
    text: "Please use the site navigation to find what you're looking for, or [Return to the home page](/)."
  }
};
export var CSS_DOTS_END = css(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  ", ";\n"], ["\n  ", ";\n"])), theme.H_DOT_BG_END('secondary', 2, 8));
export var CSS_DOTS = css(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  ", ";\n"], ["\n  ", ";\n"])), theme.H_DOT_BG('secondary', 2, 8));
var templateObject_1, templateObject_2;